import { Component, Input, OnInit, output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { TranslateModule } from '@ngx-translate/core';

import { MessageType } from '../../../../model/message.model';
import { DepositService } from '../../../../service/deposit.service';
import { ValidnumberDirective } from '../../../../shared/directives/validnumber.directive';

@Component({
    selector: 'app-flash1-voucher-input',
    templateUrl: 'flash1voucher-input.component.html',
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, ValidnumberDirective, MatError, TranslateModule],
})
export class Flash1VoucherInputComponent implements OnInit {
    @Input() voucherInputFormGroup: FormGroup;
    voucherPin = output<string>();
    constructor(public depositService: DepositService) {}
    public get messageType(): typeof MessageType {
        return MessageType;
    }

    ngOnInit(): void {
        this.voucherInputFormGroup.addControl(
            'voucherInput',
            new FormControl('', [Validators.required, Validators.minLength(16), Validators.maxLength(16)]),
        );
    }

    validateVoucherInput() {
        this.voucherPin.emit(this.voucherInputFormGroup?.controls?.['voucherInput']?.value);
    }

    numberOnly(event: any) {
        const charCode = event?.which ? event?.which : event?.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
            return false;
        }
        return true;
    }
}
